<template>
  <div>
    <v-row>
      <v-col cols="12">
        <label class="text-h6">Filtros</label>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-autocomplete
          :items="franchises"
          :item-text="(item) => `${item.code} - ${item.name}`"
          item-value="id"
          v-model="filter.franchise"
          label="Franqueado"
          :disabled="disabledFranchise"
          hide-details
          autofocus
          clearable
          dense
          outlined
        ></v-autocomplete>
      </v-col>
      <v-col>
        <v-autocomplete
          :items="collections"
          :item-text="(item) => `${item.name}`"
          item-value="id"
          v-model="filter.collection"
          label="Coleção"
          multiple
          chips
          dense
          outlined
        >
          <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index === 0">
              <span>{{ item.name }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text text-caption">
              (+{{ filter.collection.length - 1 }} outros)
            </span>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col>
        <v-select
          :items="typeProviders"
          label="Tipo de Fornecedor"
          v-model="filter.type_provider"
          dense
          outlined
        ></v-select>
      </v-col>
      <v-col>
        <v-autocomplete
          :items="providers"
          label="Fornecedor"
          multiple
          small-chips
          :item-text="(item) => `${item.code} - ${item.name}`"
          item-value="id"
          v-model="filter.provider"
          dense
          outlined
        >
          <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index === 0">
              <span>{{ item.code }} - {{ item.name.substring(0, 20) }}...</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text text-caption">
              (+{{ filter.provider.length - 1 }} outros)
            </span>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-autocomplete
          :items="categories"
          label="Categoria"
          :item-text="(item) => `${item.name}`"
          item-value="id"
          dense
          outlined
          v-model="filter.category"
          @change="handleChangeCategories()"
        ></v-autocomplete>
      </v-col>
      <v-col>
        <v-autocomplete
          :items="subcategories"
          :item-text="(item) => `${item.name}`"
          item-value="id"
          v-model="filter.subcategory"
          label="Subcategoria"
          dense
          outlined
        ></v-autocomplete>
      </v-col>
      <v-col>
        <v-select
          :items="yesOrNo"
          :item-text="(item) => `${item.name}`"
          item-value="id"
          v-model="filter.marketing"
          label="Filtrar somente Marketing?"
          dense
          outlined
        ></v-select>
      </v-col>
      <v-col>
        <v-select
          :items="yesOrNo"
          :item-text="(item) => `${item.name}`"
          item-value="id"
          v-model="filter.opportunity"
          label="Filtrar somente Oportunidade?"
          dense
          outlined
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn
          color="blue darken-3"
          dark
          class="mt-1"
          @click="searchProducts()"
        >
          <v-icon left>mdi-filter</v-icon> Buscar
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import * as CompanyAPI from "@/api/requests/CompanyRequest";
import * as CollectionAPI from "@/api/requests/CollectionRequest";
import * as CategoryAPI from "@/api/requests/CategoryRequest";
import * as SubcategoryAPI from "@/api/requests/SubcategoryRequest";

export default {
  props: {
    filter: {
      type: Object,
      default: function () {
        return {
          collection: [],
          provider: [],
          franchise: "",
          category: "",
          subcategory: "",
          type_provider: "",
          opportunity: "N",
          marketing: "N",
        };
      },
    },
    disabledFranchise: {
      type: Boolean,
      default: false,
    },
    searchProducts: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    collections: [],
    typeProviders: [
      { value: 2, text: "Acessários" },
      { value: 1, text: "Sapatos" },
      { value: 3, text: "Produtos de Conservação" },
    ],
    yesOrNo: [
      { id: "N", name: "Não" },
      { id: "S", name: "Sim" },
    ],
    providers: [],
    franchises: [],
    categories: [],
    subcategories: [],
  }),
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.getProviders();
      this.getFranchises();
      this.getCollections();
      this.getCategories();
    },
    async getProviders() {
      if (this.providers.length == 0) {
        this.loadingProviders = true;
        try {
          let data = await CompanyAPI.getAll("?type=for");
          this.providers = data.sort((a, b) => (a.code > b.code ? 1 : -1));
        } catch (error) {
          this.providers = [];
          console.log(error);
        } finally {
          this.loadingProviders = false;
        }
      }
    },
    async getFranchises() {
      if (this.franchises.length === 0) {
        try {
          let data = await CompanyAPI.getAll("?type=fra,mul");
          this.franchises = data.sort((a, b) => (a.code > b.code ? 1 : -1));
        } catch (error) {
          this.franchises = [];
          console.log(error);
        }
      }
    },
    async getCollections() {
      this.loadingCollections = true;
      this.collections = [];
      try {
        let data = await CollectionAPI.getAll();
        if (data.length > 0) {
          this.filter.collection.push(data[data.length - 1].id);
        }
        this.collections = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.collections = [];
        console.log(error);
      } finally {
        this.loadingCollections = false;
      }
    },
    async getCategories() {
      this.loadingCategories = true;
      this.categories = [];
      try {
        let data = await CategoryAPI.getAll();
        this.categories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.categories = [];
        console.log(error);
      } finally {
        this.loadingCategories = false;
      }
    },
    async getSubcategories(category) {
      this.loadingSubcategories = true;
      this.subcategories = [];
      try {
        let data = await SubcategoryAPI.getAll(`?category_id=${category}`);
        this.subcategories = data.sort((a, b) => (a.name > b.name ? 1 : -1));
      } catch (error) {
        this.subcategories = [];
        console.log(error);
      } finally {
        this.loadingSubcategories = false;
        // this.loading = false;
      }
    },
    handleChangeCategories() {
      this.getSubcategories(this.filter.category);
    },
  },
};
</script>
